import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { isEmpty,isUndefined } from 'lodash';
import validator from 'validator'
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {getKundKontakter} from 'actions'
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({accountsData,auth}) {
    const { Userlista,KontakterList } = accountsData;
    const { authUser } = auth;
    return {
        Userlista,KontakterList,authUser
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getKundKontakter: (userid,AFid,Orgnr) => dispatch(getKundKontakter(userid,AFid,Orgnr)),
    };
}

class SelectMultiMedArbetare extends Component {
    state={
        MedArbetare:[],
        InbjudaEmail:""
    }
    componentDidUpdate=()=>{
      if(this.state.MedArbetare !== this.props.MedArbetare){
        this.setState({
            MedArbetare:this.props.MedArbetare
        })
      }
    }
    componentDidMount=()=>{
        if(!isUndefined(this.props.isFrom)){
          if(!isUndefined(this.props.KundOrgnr)){
            const userid = this.props.authUser.user_id
            const Afid = this.props.authUser.user_Afid
            this.props.getKundKontakter(userid,Afid, this.props.KundOrgnr)
          }
        }
      }
    getData=()=>{
        let Data = []
        for(let user of this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail)})){
            Data.push(user.UserEmail2)
        }
        if(!isEmpty(this.props.KontakterList)){
            for(let user of this.props.KontakterList.filter(item=>{return !isEmpty(item.Email)})){
                Data.push(user.Email)
            }
        }
        if(!isEmpty(this.props.MedArbetare)){
            for(let user of this.props.MedArbetare){
                Data = Data.filter(item=> {
                    return item !== user.email
                })
            }
        }
        //remove Duplater
        Data = Data.filter((obj, pos, arr) => {
            return arr
              .map(mapObj => mapObj)
              .indexOf(obj) == pos;
          });
        console.log(Data,"FFF")
        return Data
    }
    onBlurHandle=(e)=>{
        if(validator.isEmail(this.state.InbjudaEmail)){
            //check if Email is allready in 
            if(isUndefined(this.props.KontaktEmail)){
            if(!this.state.MedArbetare.some(item=>item.email === this.state.InbjudaEmail)) {
                let MedArr = this.state.MedArbetare.concat({email:this.state.InbjudaEmail})
                this.setState({
                 MedArbetare:MedArr
               })
               this.props.onchangeHanelMedArbetare(MedArr)
            }
            }else{
                if(this.props.KontaktEmail !==this.state.InbjudaEmail ){
                if(!this.state.MedArbetare.some(item=>{ return item.email === this.state.InbjudaEmail})) {
                    let MedArr = this.state.MedArbetare.concat({email:this.state.InbjudaEmail})
                    this.setState({
                     MedArbetare:MedArr
                   })
                   this.props.onchangeHanelMedArbetare(MedArr)
                }
            }
            }
      this.setState({
        InbjudaEmail:""
      })
      }
    }
    handleChipDelete=(chipId)=>{
        console.log(chipId)
        let MedArr = this.state.MedArbetare.filter((n)=>{
            if(n.email !== chipId){
                return n
            }
        })
        console.log(MedArr)
        this.setState({
            MedArbetare:MedArr
          })
        this.props.onchangeHanelMedArbetare(MedArr)
    }
    onChangeHandle=(Value)=>{
        console.log(Value,"EEEEEE")
        if(validator.isEmail(Value)){
            console.log("YES")
        let MedArr = this.state.MedArbetare.concat({email:Value})
        this.setState({
            MedArbetare:MedArr
        })
        this.props.onchangeHanelMedArbetare(MedArr)
        this.setState({
            InbjudaEmail:""
        })
        }
    }
    onChangeHandle1=(e)=>{
        this.setState({
            InbjudaEmail:e.target.value
        })
    }
    render() {
        return (
            <>
            <div>
            <Autocomplete
            id="free-solo-2-demo"
            disableClearable
            clearOnBlur={true}
            size="small"
            //value={this.state.InbjudaEmail}
            disabled={isUndefined(this.props.disabled)?false:this.props.disabled}
            renderOption={(option) => (
                <React.Fragment>
                {option}
                </React.Fragment>
             )}
             /**/
            onChange={(event, newValue) => {
                this.onChangeHandle(newValue)
            }}
            onClose={()=>{
                console.log("RRRRRR")
                this.setState({
                    InbjudaEmail:""
                })
            }}
            options={this.getData()}
            renderInput={(params) => (
                <TextField
                {...params}
                variant="outlined"
                fullWidth
                //value={this.state.InbjudaEmail}
                label={<IntlMessages id="input.Participant"/>}                
                type="email"
                size="small"
                name="MdArbetare"
                disabled={isUndefined(this.props.disabled)?false:this.props.disabled}
                placeholder="Skriv E-post eller välj"
                InputProps={{ ...params.InputProps }}
                InputLabelProps={{ shrink: true }}
                onChange={this.onChangeHandle1}
                onBlur={this.onBlurHandle}
                />
            )}
            />
            </div>
            {
                !isUndefined(this.props.isFrom)?
                this.props.isFrom === 2?"":
                <div className="my-2">
                {!isEmpty(this.props.MedArbetare)?
                 this.props.MedArbetare.map((n)=>{
                    return <>
                    <Chip 
                    label={`${n.email}`} 
                    color="primary"
                    size="small"
                    className="m-1"
                    
                    onDelete={()=>{
                        if(!isUndefined(this.props.disabled)){
                        if(this.props.disabled !== true){
                          this.handleChipDelete(n.email)
                        }
                      }else{
                        this.handleChipDelete(n.email)
                      }}}
                    />
                    </>                   
                    
                })
                :""}
            </div>:
             <div className="my-2">
             {!isEmpty(this.props.MedArbetare)?
              this.props.MedArbetare.map((n)=>{
                 return <>
                 <Chip 
                 label={`${n.email}`} 
                 color="primary"
                 size="small"
                 className="m-1"
                 
                 onDelete={()=>{
                     if(!isUndefined(this.props.disabled)){
                     if(this.props.disabled !== true){
                       this.handleChipDelete(n.email)
                     }
                   }else{
                     this.handleChipDelete(n.email)
                   }}}
                 />
                 </>                   
                 
             })
             :""}
         </div>
            }
           
            </>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(SelectMultiMedArbetare);